document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('.ussf-header-mobile__menu');
  const searchBtn = document.querySelector('.ussf-header-mobile__search');

  // Open Dawn menu drawer
  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      const drawer = document.querySelector('header-drawer details');
      if (drawer) {
        drawer.setAttribute('open', '');
        menuBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // Open Dawn search modal
  if (searchBtn) {
    searchBtn.addEventListener('click', () => {
      const searchToggle = document.querySelector('.header__icon--search');
      if (searchToggle) {
        searchToggle.click();
      }
    });
  }
});
